import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
// ⚠️ MAINTENANCE MODE - All routes disabled except admin dashboard
// Remove this and restore original App.tsx when security fixes are complete
function MaintenancePage() {
  return <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a0a2e 0%, #2d1b4e 50%, #1a0a2e 100%)',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    padding: '24px'
  }} data-id="element-0">
      <div style={{
      textAlign: 'center',
      maxWidth: '520px',
      color: 'white'
    }} data-id="element-1">
        <div style={{
        width: '80px',
        height: '80px',
        margin: '0 auto 32px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '36px'
      }} data-id="element-2">
          🔧
        </div>
        <h1 style={{
        fontSize: '28px',
        fontWeight: '700',
        marginBottom: '16px',
        color: '#fff'
      }} data-id="element-3">
          Under Maintenance
        </h1>
        <p style={{
        fontSize: '18px',
        fontWeight: '600',
        marginBottom: '8px',
        color: '#d4b8e8',
        direction: 'rtl'
      }} data-id="element-4">
          الموقع تحت الصيانة
        </p>
        <p style={{
        fontSize: '15px',
        lineHeight: '1.7',
        color: 'rgba(255,255,255,0.7)',
        marginBottom: '12px'
      }} data-id="element-5">
          We're performing important security updates to improve your
          experience. We'll be back shortly.
        </p>
        <p style={{
        fontSize: '15px',
        lineHeight: '1.7',
        color: 'rgba(255,255,255,0.7)',
        direction: 'rtl',
        marginBottom: '32px'
      }} data-id="element-6">
          نقوم بإجراء تحديثات أمنية مهمة لتحسين تجربتك. سنعود قريباً.
        </p>
        <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 20px',
        borderRadius: '999px',
        background: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(255,255,255,0.12)',
        fontSize: '13px',
        color: 'rgba(255,255,255,0.5)'
      }} data-id="element-7">
          <span style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          background: '#f59e0b',
          display: 'inline-block',
          animation: 'pulse 2s infinite'
        }} data-id="element-8" />
          Operines Team
        </div>
        <style data-id="element-9">{`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.4; }
          }
        `}</style>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        {/* Admin dashboard remains accessible for security fixes */}
        <Route path="/Admin-dashboard" element={<AdminDashboardPage data-id="element-13" />} data-id="element-12" />
        {/* All other routes show maintenance page */}
        <Route path="*" element={<MaintenancePage data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}